/**
 * FormSection - Reusable form section component with icon and title
 *
 * Provides consistent styling for form sections throughout the application.
 */

import type { ReactNode } from "react";

interface FormSectionProps {
  /** Section title */
  title: string;
  /** Icon element (from lucide-react or other icon library) */
  icon: ReactNode;
  /** Form fields and content */
  children: ReactNode;
  /** Optional CSS class for custom styling */
  className?: string;
}

export function FormSection({
  title,
  icon,
  children,
  className = "",
}: FormSectionProps) {
  return (
    <div
      className={`bg-white rounded-xl shadow border border-gray-200 p-6 mb-6 ${className}`}
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
          {icon}
        </div>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      </div>
      {children}
    </div>
  );
}
